import axios from 'axios';

function getSelectedAccount() {
  try {
    return localStorage.getItem('selected_account') || '';
  } catch (e) {
    return '';
  }
}

const api = axios.create({
  baseURL: '',
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use((config) => {
  const ventooPassword = sessionStorage.getItem('ventoo_password');
  const selectedAccount = getSelectedAccount();

  if (selectedAccount) {
    config.headers['x-account'] = selectedAccount;
  }

  if (ventooPassword && config.url && config.url.startsWith('/api/ventoo')) {
    config.headers['x-ventoo-password'] = ventooPassword;
  }

  return config;
});

export default api;
